export const useI18permissionsValue = t => {
  const permissionsValue = [
    {
      id: "accelerometer",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.1"),
      description: "-",
    },
    {
      id: "accessibility",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.2"),
      description: "-",
    },
    {
      id: "ambient-light-sensor",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.3"),
      description: "-",
    },
    {
      id: "camera",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.4"),
      description: "-",
    },
    {
      id: "clipboard-read",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.5"),
      description: "-",
    },
    {
      id: "clipboard-write",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.6"),
      description: "-",
    },
    {
      id: "geolocation",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.7"),
      description: "-",
    },
    {
      id: "background-sync",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.8"),
      description: "-",
    },
    {
      id: "magnetometer",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.9"),
      description: "-",
    },
    {
      id: "microphone",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.10"),
      description: "-",
    },
    {
      id: "midi",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.11"),
      description: "-",
    },
    {
      id: "notifications",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.12"),
      description: "-",
    },
    {
      id: "payment-handler",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.13"),
      description: "-",
    },
    {
      id: "persistent-storage",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.14"),
      description: "-",
    },
    {
      id: "push",
      indicator: t("scannerFingerprint.JS.permissionsValue.indicator.15"),
      description: "-",
    },
  ];

  return { permissionsValue };
};
